<template>
  <model-form
    ref="modelForm"
    :model="titleClass"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <model-form-input
          field="name"
          class="col-4"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
        <model-form-input
          field="description"
          class="col-4"
          label="Description"
        />
        <div class="col-4 row justify-center items-center">
          <q-btn
            :color="titleClass.color"
            glossy
            unelevated
            :style="'background-color: ' + titleClass.color"
            size="lg"
            class="col"
          >
            <div class="text-caption text-weight-light">
              <div class="text-capitalize">
                {{ titleClass.color }}
              </div>
            </div>
            <q-menu
              anchor="top left"
              self="top left"
            >
              <q-color v-model="titleClass.color" />
            </q-menu>
          </q-btn>
        </div>
      </div>
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'TitleClassForm',
  components: {
    ModelForm
  },
  models: {
    titleClass: 'default'
  }
}

</script>
